module.exports = __webpack_public_path__ + "img/hero-mobile.c1b13ec3.png";